import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/who-we-are", label: "Who We Are" },
  { to: "/what-we-do", label: "What We Do" },
  { to: "/political-consulting", label: "Political Consulting" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy", label: "Privacy" },
];

const Footer = () => (
  <footer className="bg-ink text-cream" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 text-sm leading-relaxed text-cream/70 max-w-sm">
            Strategic Communications | Public Affairs | Community Engagement | Political Consulting
          </p>
          <p className="mt-8 font-serif italic text-lg text-gold">
            Connecting communities | Opening possibilities | Navigating opportunities
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-5">Contact</p>
          <address className="not-italic text-sm leading-loose text-cream/80">
            Mosaicon Strategies<br />
            Greater Toronto Area, Ontario, Canada<br />
            <a href="tel:+14165684178" className="link-underline" data-testid="footer-phone">416.568.4178</a><br />
            <a href="mailto:mku@mosaicons.ca" className="link-underline" data-testid="footer-email">mku@mosaicons.ca</a><br />
            <a href="https://www.mosaicons.ca" className="link-underline" data-testid="footer-website">www.mosaicons.ca</a>
          </address>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-5">Navigate</p>
          <nav className="grid grid-cols-2 gap-x-8 gap-y-3" aria-label="Footer">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="link-underline text-sm text-cream/80 hover:text-cream transition-colors duration-300 w-fit"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-cream/50 tracking-wide" data-testid="footer-copyright">
          © 2026 Mosaicon Strategies. All Rights Reserved.
        </p>
        <p className="text-xs text-cream/50 tracking-[0.2em] uppercase">
          Greater Toronto Area · Ontario · Canada
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
